// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__6LOe0","Spinner":"spinner_Spinner__P2acB"};